import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormArray, FormsModule } from '@angular/forms';
import { ContentMapperService } from '../../../core/services/content-mapper-service';
import { ToastrService } from 'ngx-toastr';
import { ttd_endpoint } from '../../../data/api-endpoint/ttd-endpoint';
import { Loader } from '../../../../shared/components/loader/loader';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MultiLevelDropdown } from '../../../../shared/components/multi-level-dropdown/multi-level-dropdown';
import { environment } from '../../../../environments/environment';
import { NumberSuffixPipe } from '../../../../shared/pipes/number-suffix-pipe';

@Component({
  selector: 'app-content-pool',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, Loader, MultiLevelDropdown, NumberSuffixPipe],
  templateUrl: './content-pool.html',
  styleUrl: './content-pool.scss'
})
export class ContentPool implements OnInit {
  loading: boolean = false;
  editMode: boolean = false;
  contentMapperForm!: FormGroup;
  isSubmitted = signal<boolean>(false);
  binIconPath = 'assets/img/bin.png';
  leftArrow = 'assets/img/left.png';

  filterTokenId:string = '';
  contentPoolOperation: string = 'Create'
  pool_id!: string
  customWidth = signal<boolean>(true);
  selectedCategoryies: WritableSignal<Set<number>> = signal(new Set());

  alreadyAddedKeywords: Record<string, boolean> = {}
  selectedFieldsByIndex: string[] = []

  currentIndex: any
  categories: any[] = []
  contentPoolPreview: Record<string, number> = {}

  runPreview: boolean = true;
  previousContentPoolData : any = {};


  conditionOptions = [{ name: 'Include', value: true }, { name: 'Exclude', value: false }];
  operatorOptions = ['=', '!=', '>', '<', ">=", "<=", "IN", "ILIKE"];
  fieldName = [{ name: 'Keywords', value: 'keywords' }, { name: 'Categories', value: 'categories' },
  { name: 'Topics', value: 'topics' }, { name: 'Movies/Series', value: 'movies' }, { name: 'IMDB', value: 'imdb' }, { name: 'Source', value: 'source' },
  { name: 'Actor Name', value: 'actor_name' }, { name: 'Release Year', value: 'release_year' }]

  operatorOptionsByField = {
    'categories': 'IN',
    'imdb': 'IN',
    'keywords':'ILIKE',
    'topics': 'ILIKE',
    'movies': 'ILIKE',
    'release_year': '=',
    'actor_name': 'ILIKE',
    'source': 'ILIKE'
  }

  constructor(private _formBuilder: FormBuilder, private _contentMapper: ContentMapperService,
    private toastr: ToastrService, private _router: Router, private _route: ActivatedRoute) {

  }

  ngOnInit(): void {
    this.fetchCustomCategory();
    this.contentMapperForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      desc: [''],
      filterQuery: this._formBuilder.array([this.newClause()]),
      brand_safety: ["false"]
    })

    const firstField = (this.filterQuery.at(0) as FormGroup).get('field')?.value as string;
    this.selectedFieldsByIndex[0] = firstField;

    this._route.paramMap.subscribe(params => {
      const dynamicId = params.get('id');
      if (dynamicId) {
        this.pool_id = dynamicId;
        this.editMode = true;
        this.contentPoolOperation = 'Edit'
        const fq = this.contentMapperForm.get('filterQuery') as FormArray;
        fq.clear();
        this.fetchContenPoolDetail()
      }
    });
  }

  get f() { return this.contentMapperForm.controls; }

  get filterQuery(): FormArray {
    return this.contentMapperForm.get('filterQuery') as FormArray;
  }

  getCategoryFormArray(index: number): FormArray {
    const filterGroup = this.filterQuery.at(index) as FormGroup;
    return filterGroup.get('category') as FormArray;
  }


  getClauseControl(index: number, controlName: string) {
    const group = this.filterQuery.at(index) as FormGroup;
    return group ? group.get(controlName) : null;
  }

  hasClauseError(index: number, controlName: string, errorKey: string): boolean {
    const control = this.getClauseControl(index, controlName);
    return !!control && control.hasError(errorKey);
  }


  private categoryValidator(control: any) {
    const field = control.get('field')?.value;
    const categories = control.get('category')?.value;

    if (field === 'categories' && (!categories || categories.length === 0)) {
      return { categoryRequired: true };
    }

    return null;

  }

  newClause() {
    const values = ["keywords", "categories", "topics", "movies", "imdb", "source",
      "actor_name", "release_year"];
    const fieldValue: string = values.find(value => !this.alreadyAddedKeywords[value]) || "";

    if (fieldValue) {
      this.alreadyAddedKeywords[fieldValue] = true;
    }

    const group = this._formBuilder.group({
      condition: [true, Validators.required],
      field: [fieldValue, Validators.required],
      operator: ['ILIKE', Validators.required],
      value: [''],
      logicalOperator: ['AND', Validators.required],
      category: this._formBuilder.array([])
    }, { validators: this.categoryValidator.bind(this) });

    this.applyValueConditionalValidator(group);
    return group;
  }


  get isFilterFilled() {
    const formArray = this.contentMapperForm.get('filterQuery') as FormArray
    return formArray.length > 0 ? false : true;
  }

  private applyValueConditionalValidator(group: FormGroup): void {
    const fieldControl = group.get('field');
    const valueControl = group.get('value');
    if (!fieldControl || !valueControl) {
      return;
    }

    const setValidatorsForField = (fieldValue: string) => {
      if (fieldValue === 'categories') {
        valueControl.clearValidators();
      } else {
        valueControl.setValidators([Validators.required]);
      }
      valueControl.updateValueAndValidity({ emitEvent: false });
    };

    setValidatorsForField(fieldControl.value as string);
    fieldControl.valueChanges.subscribe((fv: string) => setValidatorsForField(fv));
  }

  goToContentPoolListing() {
    this._router.navigate(['/content-pool'])
  }

  checkIsErrorMessageValid(error: any) {
    if(typeof error?.error?.message === 'string') {
      return error?.error?.message;
    }
    return 'An unknow error occured';
  }



  addClause() {
    if(this.filterQuery.length == 8){
      this.toastr.error('You can only add 8 filters');
      return;
    }
    this.isSubmitted.set(false);
    this.filterQuery.push(this.newClause());
    const idx = this.filterQuery.length - 1;
    const field = (this.filterQuery.at(idx) as FormGroup).get('field')?.value as string;
    const operator = this.operatorOptionsByField[field as keyof typeof this.operatorOptionsByField];
    (this.filterQuery.at(idx) as FormGroup).get('operator')?.setValue(operator);
    this.selectedFieldsByIndex[idx] = field;
    this.runPreview = true
  } 

  removeClause(index: number) {
    this.isSubmitted.set(false);
    const FormArray = this.contentMapperForm.get('filterQuery') as FormArray;
    delete this.alreadyAddedKeywords[FormArray.at(index).get('field')?.value];
    FormArray.removeAt(index);
    this.selectedFieldsByIndex.splice(index, 1);
    this.runPreview = true
  }

  onFieldChange(event: any, index: number) {
    const formArray = this.contentMapperForm.get('filterQuery') as FormArray;
    const currentControl = formArray.controls[index];
    const fieldValue = event.target.value;
    const previousField = this.selectedFieldsByIndex[index];

    const categoryFormArray = currentControl.get('category') as FormArray;
    const valueControl = currentControl.get('value');


    categoryFormArray.clear();
    this.isSubmitted.set(false);

    switch (fieldValue) {
      case 'release_year':
        currentControl.get('operator')?.setValue('=');
        valueControl?.setValidators([Validators.required]);
        valueControl?.updateValueAndValidity();
        break;
      case 'categories':
        valueControl?.setValue('');
        valueControl?.markAsUntouched();
        valueControl?.markAsPristine();
        valueControl?.clearValidators();
        valueControl?.updateValueAndValidity();
        currentControl.get('operator')?.setValue('IN');
        break;
      case 'imdb':
          valueControl?.setValue('');
          valueControl?.markAsUntouched();
          valueControl?.markAsPristine();
          valueControl?.setValidators([Validators.required]);
          valueControl?.updateValueAndValidity();
          currentControl.get('operator')?.setValue('IN');
          break;
      default:
        currentControl.get('operator')?.setValue('ILIKE');
        valueControl?.setValidators([Validators.required]);
        valueControl?.updateValueAndValidity();
        break;
    }

    if (previousField && previousField !== fieldValue) {
      delete this.alreadyAddedKeywords[previousField];
    }
    this.alreadyAddedKeywords[fieldValue] = true;
    this.selectedFieldsByIndex[index] = fieldValue;
    this.runPreview = true

  }


  resetForm() {
    this.isSubmitted.set(false);
    this.contentMapperForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      desc: [''],
      filterQuery: this._formBuilder.array([this.newClause()]),
      brand_safety: ["false"]
    });

    const fq = this.contentMapperForm.get('filterQuery') as FormArray;
    fq.clear();

    if(Object.keys(this.previousContentPoolData).length > 0) {
      this.patchContentPoolDetail(structuredClone(this.previousContentPoolData));
      return 
    }
   
    this.contentPoolPreview = {};
    this.alreadyAddedKeywords = { keywords: true }
    this.selectedFieldsByIndex = [
      (this.filterQuery.at(0) as FormGroup)?.get('field')?.value as string
    ]
    this.runPreview = true
  }



  addItemInFormArray(e: any, index: number, type: string) {
    const { data, level } = e as any
    const isChecked = (e.event.target as HTMLInputElement).checked;
    const filterGroup = this.filterQuery.at(index) as FormGroup;
    const formArray = filterGroup.get(type) as FormArray;


    formArray.clear();


    switch (`${level}-${isChecked}`) {
      case 'greatParent-true':
        data.forEach((cat: string) => {
          formArray.push(this._formBuilder.control(cat));
        });
        break;
      case 'parent-true':
        data.forEach((cat: string) => {
          formArray.push(this._formBuilder.control(cat));
        });
        break;
      case 'child-true':
        data.forEach((cat: string) => {
          formArray.push(this._formBuilder.control(cat));
        });
        break;
      case 'grandChild-true':
        data.forEach((cat: string) => {
          formArray.push(this._formBuilder.control(cat));
        });
        break;

      case 'greatParent-false':
        data.forEach((cat: string) => {
          formArray.push(this._formBuilder.control(cat));
        });
        break;
      case 'parent-false':
        data.forEach((cat: string) => {
          formArray.push(this._formBuilder.control(cat));
        });
        break;
      case 'child-false':
        data.forEach((cat: string) => {
          formArray.push(this._formBuilder.control(cat));
        });
        break;
      case 'grandChild-false':
        data.forEach((cat: string) => {
          formArray.push(this._formBuilder.control(cat));
        });
        break;
    }
    this.runPreview = true
  }





  removeItemFormArray(parent_index: number, index: number, type: string) {
    const filterGroup = this.filterQuery.at(parent_index) as FormGroup;
    const formArray = filterGroup.get(type) as FormArray;
    formArray.removeAt(index)
    this.runPreview = true
  }



  checkedAll(checked: boolean, data: any, index: number, type: string) {
    const filterGroup = this.filterQuery.at(index) as FormGroup;
    const formArray = filterGroup.get(type) as FormArray;
    const { categorySet } = data
    if (checked) {
      formArray.clear();
      categorySet.forEach((element: any) => {
        formArray.push(this._formBuilder.control(element));
      });
    } else {
      formArray.clear();
    }
    this.runPreview = true
  }


  fetchCustomCategory() {
    this._contentMapper.get(ttd_endpoint.custom_categories).subscribe({
      next: (response: any) => {
        this.categories = response.results;

      }, error: (error) => {
        this.toastr.error(this.checkIsErrorMessageValid(error));
        console.error('Error occured while fetching category', error.message)
        this.categories = []

      }
    })
  }

  saveContentPool(isSaved: boolean = false) {
    this.isSubmitted.set(true);
    this.contentMapperForm.markAllAsTouched();

    if (this.contentMapperForm.invalid) {
      this.toastr.error('Please fill all the required fields');
      return
    }

    const { name, desc, filterQuery,brand_safety } = this.contentMapperForm.value;
    const filters = filterQuery.reduce((acc: Record<string, any>, curr: any) => {
      let value: any;
      const isCategoryField = curr['field'] === 'categories';

      if (Array.isArray(curr['value'])) {
        curr['value'] = curr['value'][0]
      }

      if (!isCategoryField) {
        value = Array.isArray(curr['value']) ? curr['value'] : curr['value'].split(',');
      } else {
        const categoryValues = curr['category'];
        value =  Array.isArray(categoryValues) ?  categoryValues : categoryValues.split(',');
      }
      acc[curr['field']] = {
        operator: curr['operator'],
        value: value,
        logic: curr['logicalOperator'],
        include: typeof curr['condition'] === 'boolean' ? curr['condition'] : curr['condition'] === 'true' ? true : false
      }
      return acc
    }, {});


    const { totalRequest = null, brandSafe = null, mappedAssets = null,totalSuccessRequests=null } = this.contentPoolPreview

    const final_data = {
      name, description: desc,
      filters,
      save: isSaved,
      brandSafety:brand_safety == 'true' ? true : false,
      totalRequest,
      brandSafe,
      mappedAssets,
      totalSuccessRequests
    }


    this.loading = true;
    this._contentMapper.post(isSaved ? ttd_endpoint.save : ttd_endpoint.search, final_data).subscribe({
      next: (response: any) => {
        if (isSaved) {
          this.resetForm()
          this.toastr.success(response.message);
          this.goToContentPoolListing();
          this.alreadyAddedKeywords = { }
          this.selectedFieldsByIndex = []

        } else {
          this.runPreview = false;
          const contentPoolPreview = response.results.length > 0 ? response.results[0] : {};
          this.contentPoolPreview = contentPoolPreview
          this.filterTokenId = contentPoolPreview.filterToken
        }
        this.loading = false;
      }, error: (error) => {
        this.loading = false;
        console.error("Error occured while searching or saving content pool", error.message)
        this.toastr.error(this.checkIsErrorMessageValid(error));
      }

    })
  }




  fetchContenPoolDetail() {
    this.loading = true
    this._contentMapper.get(ttd_endpoint.ContentPool + `/${this.pool_id}`).subscribe({
      next: (response: any) => {
        this.loading = false
        this.previousContentPoolData = response.results?.length > 0 ? response.results[0] : {};
        this.patchContentPoolDetail(structuredClone(this.previousContentPoolData));
      }, error: (error) => {
        this.loading = false;
        console.error("Error occured while fetching content pool detail", error.message)
        this.toastr.error(this.checkIsErrorMessageValid(error));
      }
    })
  }


  patchContentPoolDetail(contentPool: any) {
    this.contentPoolPreview = {
      totalRequest: contentPool.total_requests || null,
      brandSafe: contentPool.brand_safe || null,
      mappedAssets: contentPool.mapped_assets || null,
      totalSuccessRequests: contentPool.total_success_requests || null
    }
    this.filterTokenId = contentPool.filterToken || '-'
    const { name, description, filter,brandSafety } = contentPool;
    this.contentMapperForm.get('name')?.patchValue(name);
    this.contentMapperForm.get('desc')?.patchValue(description)
    this.contentMapperForm.get('brand_safety')?.patchValue(brandSafety   ? "true" : "false");
    this.alreadyAddedKeywords = { };

    const filter_list = Object.entries(filter).reduce((acc: any, [key, value]: any) => {
      let final_value = value.value
      if (Array.isArray(value.value)) {
        final_value = value.value.join(',')
      }
      this.alreadyAddedKeywords[key] = true;
      const filter_dict = {
        field: key,
        logicalOperator: value.logic,
        condition: value.include,
        operator: value.operator,
        category: key == 'categories' ? value.value.map((item: any) => item) : [],
        value: key != 'categories' ? Array.isArray(final_value) ? final_value.join(',') : final_value : ''
      }
      acc.push(filter_dict);
      return acc
    }, []);

    this.selectedFieldsByIndex = [];
    filter_list.forEach((item: any, idx: number) => {
      const formGroup = this._formBuilder.group({
        condition: [item.condition, Validators.required],
        field: [item.field, Validators.required],
        operator: [item.operator, Validators.required],
        value: [item.value],
        logicalOperator: [item.logicalOperator, Validators.required],
        category: this._formBuilder.array(item.category || [])
      }, { validators: this.categoryValidator.bind(this) });

      this.applyValueConditionalValidator(formGroup);
      this.filterQuery.push(formGroup);
      this.selectedFieldsByIndex[idx] = item.field as string;
    });
  }


  updateContentPool() {

    this.isSubmitted.set(true);
    if (this.contentMapperForm.invalid) {
      this.toastr.error('Please fill all the required fields');
      return
    }

    const { name, desc, filterQuery,brand_safety } = this.contentMapperForm.value;

    const filters = filterQuery.reduce((acc: Record<string, any>, curr: any) => {
      let value: any;
      const isCategoryField = curr['field'] === 'categories';

      if (Array.isArray(curr['value'])) {
        curr['value'] = curr['value'][0]
      }

      if (!isCategoryField) {
        value = Array.isArray(curr['value']) ? curr['value'] : curr['value'].split(',');
      } else {
        const categoryValues = curr['category'];
        value =  Array.isArray(categoryValues) ?  categoryValues : categoryValues.split(',');
      }

      acc[curr['field']] = {
        operator: curr['operator'],
        value: value,
        logic: curr['logicalOperator'],
        include: typeof curr['condition'] === 'boolean' ? curr['condition'] : curr['condition'] === 'true' ? true : false
      }
      return acc
    }, {});


    const { totalRequest = null, brandSafe = null, mappedAssets = null,totalSuccessRequests=null } = this.contentPoolPreview
    

    const final_data = {
      name, description: desc,
      filters,
      brandSafety:brand_safety == 'true' ? true : false,
      totalRequest, brandSafe, mappedAssets,totalSuccessRequests
    }
    this._contentMapper.put(ttd_endpoint.save + `/${this.pool_id}`, final_data).subscribe({
      next: (response: any) => {
        this.toastr.success(response.message);
        this.isSubmitted.set(false);
        this.alreadyAddedKeywords = { }
        this.selectedFieldsByIndex = []
        this.goToContentPoolListing();
      }, error: (error) => {
        console.error("Error occured while updating content pool", error.message)
        this.toastr.error(this.checkIsErrorMessageValid(error));
        this.isSubmitted.set(false);
      }
    })
  }


  navigateToContentPoolAssets() {
    if(!this.filterTokenId) return;
    window.open(`${environment.frontendEndUrl}/content-pool/content-pool-assets/${this.filterTokenId}`, '_blank')
  }



}
